/**
 * FilterValidatorRule type definition
 * @typedef {function} FilterValidatorRule
 * @param {*} subject
 * @returns {boolean|string}
 */

/**
 * FilterValidate type definition
 * @typedef {function} FilterValidate
 * @param {*} subject
 * @param {FilterValidatorRule[]} rules
 */

/**
 * FilterValidator type definition
 * @typedef {Object} FilterValidatorType
 * @property {FilterValidate} validate - Validates subject against rules
 * @property {FilterValidatorRule} isObject - Rule - checks if subject is an object
 * @property {FilterValidatorRule} isArray - Rule - checks if subject is an array
 * @property {FilterValidatorRule} isString - Rule - checks if subject is a string
 * @property {FilterValidatorRule} isBool - Rule - checks if subject is a boolean
 * @property {FilterValidatorRule} isSingleKey - Rule - checks if subject has exactly one key
 * @property {FilterValidatorRule} isArrayInFirstKey - Rule - checks if subject has an array as a value of the first key
 * @property {FilterValidatorRule} arrayInFirstKeyHasTwoValues - Rule - checks if subject has exactly two values in the first key
 */

/**
 * FilterValidator used to validate filter syntax
 * @type {FilterValidatorType}
 */
const FilterValidator = {
    validate: (subject, rules) => {
        for (const rule of rules) {
            const message = rule(subject);
            if (message !== true) {
                window.console.warn(message);
            }
        }
    },
    isObject: value => (typeof value === 'object' && value !== null && !Array.isArray(value)) || 'Invalid filter syntax, expected object: `{operator: value}',
    isArray: value => Array.isArray(value) || 'Invalid filter syntax, expected array: `[{operator: value}, {operator2: value2}, ...]',
    isString: value => Object.prototype.toString.call(value) === "[object String]" || 'Invalid filter syntax, expected string: `property_name`',
    isBool: value => (typeof value === 'boolean') || 'Invalid filter syntax, expected boolean: `property_name`',
    isSingleKey: value => Object.keys(value).length === 1 || 'Invalid filter syntax, expected exactly one object key: `{operator: value}`!',
    isArrayInFirstKey: value => Array.isArray(Object.values(value)[0]) || 'Invalid filter syntax, expected array as a value of the first key: `{operator: [...values]}`!',
    arrayInFirstKeyHasTwoValues: value => Object.values(value)[0].length === 2 || 'Invalid filter syntax, expected exactly two operator values: `{operator: [value1, value2]}`!'
};

export {FilterValidator};
